export default __webpack_public_path__ + "static/media/avatar-unisex.138aa366.jpg";